import DropdownSelect from 'components/DropdownSelect';
import { useIntegrationAgentsMultiSelector } from 'IntegrationModule/components/IntegrationAgentsMultiSelector/useIntegrationAgentsMultiSelector';
import { FC } from 'react';

export const IntegrationAgentsMultiSelector: FC<
  ReturnType<typeof useIntegrationAgentsMultiSelector>
> = (props) => {
  return (
    <DropdownSelect<string>
      showSearchBar
      inputLabel={'Service Names'}
      items={props.integrationAgentItems}
      itemHash={
        Object.keys(props.integrationDisplayNamesHash).length > 0
          ? props.integrationDisplayNamesHash
          : null
      }
      labelKey={props.labelKey}
      selectedItems={props.selectedIntegrationAgents}
      onSelect={props.onSelectIntegrationAgent}
      isMultiSelect
    />
  );
};
